<template>
  <div id="app">
    <router-view />
    <el-dialog 
      :visible.sync="noMerchantShow"
      :close-on-click-modal="false"
      :show-close="false"
      width="600px">
      <div class="no-merchant-tip">
          <div class="img-none"></div>
          <div class="text">抱歉，未查询到该运营商信息，请检查网址是否正确</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cookiesList, getCookie } from './utils/cookies'
export default {
  data() {
    return {
      noMerchantShow: false
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        console.log('navbar-route', route)
        if (['/dealer/index','/dealer/goods/list'].indexOf(route.path) >=0) {
          let qMid = route.query.mid;
          let cMid = getCookie(cookiesList.merchant_id);
          if ((!qMid || isNaN(qMid)) && cMid) {
            this.$router.replace({ path: route.path, query: { ...route.query, mid: cMid}})                 
          } else {
            this.$store.dispatch('setMerchantId', {mid: route.query.mid, page: 'list'}).then(() => {
              let mid = getCookie(cookiesList.merchant_id)
              if (!mid || isNaN(mid)) {
                this.noMerchantShow = true
              } else {
                this.noMerchantShow = false
              }
            })
          }
          
        } else {
          this.$store.dispatch('setMerchantId', {mid: route.query.mid, page: 'other'}).then(() => {
            let mid = getCookie(cookiesList.merchant_id)
            if (!mid || isNaN(mid)) {
              this.noMerchantShow = true
            } else {
              this.noMerchantShow = false
            }
          })
        }
        
      },
      immediate: true
    }
  },
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.no-merchant-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0 50px;
    .img-none {
        width: 240px;
        height: 126px;
        background: url(./assets/img_no_login.png) no-repeat;
        background-size: cover;
    }
    .text {
        font-size: 16px;
        color: #000000;
        line-height: 32px;
    }
}
</style>
